// extracted by mini-css-extract-plugin
export var productImage = "_kc-1";
export var viewLink = "_kc-2";
export var wishlistItem = "_kc-0";